//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import head from 'lodash/head'

import {
  getRoeCookie,
  getSortedCountries,
  removeRoeCookie,
  removeSetCurrencyCookie,
  setCurrencyPreference,
  setRoeCookie,
} from '@/scripts/libs/country-selector'
import { NoEcommerce } from '@/scripts/libs/no-ecommerce'

export default {
  name: 'rb-country-selector-mobile',
  props: {
    selected: String,
    countryselectorUrl: String,
  },
  data: function () {
    return {
      flagSelected: null,
      locales: [],
      value: undefined,
      oldLabel: null,
    }
  },
  mounted: function () {
    this.fillLocales()
    if (this.selected.includes('/eu')) {
      const euSelected = getRoeCookie()
      if (euSelected) {
        this.value = this.locales.find((v) => euSelected === v.akamaiCC)
      } else {
        this.value = this.locales.find((v) => this.selected.includes(v.url))
      }
      this.flagSelected = this.value
        ? {
            iconFlag: this.value.iconFlag,
            label: this.value.label,
          }
        : null
    } else if (
      NoEcommerce.getNoEcommerceCountry() ||
      NoEcommerce.isStoreInNoEcommerceCountries(this.value?.akamaiCC)
    ) {
      const noEcomSelected = NoEcommerce.getNoEcommerceCountry()
      if (noEcomSelected) {
        this.value = this.locales.find((v) => noEcomSelected === v.akamaiCC)
      } else {
        this.value = this.locales.find((v) => this.selected === v.id)
      }
      this.flagSelected = this.value
        ? {
            iconFlag: this.value.iconFlag,
            label: this.value.label,
          }
        : null
      this.currentCountry = this.value
    } else {
      removeRoeCookie()
      removeSetCurrencyCookie()
      NoEcommerce.removeNoEcommerceCookie()
      this.value = this.locales.find((v) => this.selected.includes(v.url))
      this.flagSelected = this.value
        ? {
            iconFlag: this.value.iconFlag,
            label: this.value.label,
          }
        : null
    }
  },
  methods: {
    fillLocales() {
      this.locales = getSortedCountries()
      const noEcommerceCountry = NoEcommerce.getNoEcommerceCountry()
      let selectedCountry = undefined
      if (noEcommerceCountry) {
        selectedCountry = this.locales?.find((locale) => locale.akamaiCC === noEcommerceCountry)
      } else {
        selectedCountry = this.locales?.find((locale) => this.selected.includes(locale.url))
      }
      this.value = selectedCountry
    },
    onChange(event) {
      localStorage.clear()
      sessionStorage.clear()
      removeRoeCookie()
      removeSetCurrencyCookie()
      NoEcommerce.removeNoEcommerceCookie()

      const selectedLabel = head(event?.target?.selectedOptions)?.label

      const selectedCountry = this.locales.find((locale) => locale.label === selectedLabel)

      let requestedCountryURL = ''
      this.oldLabel = this.value.label
      this.flagSelected = { iconFlag: selectedCountry.iconFlag, label: selectedCountry.label }

      let selectedCookie = undefined
      if (selectedCountry.url.includes('/eu')) {
        setRoeCookie(selectedCountry.akamaiCC)
        NoEcommerce.removeNoEcommerceCookie()
        selectedCookie = getRoeCookie()
      } else if (NoEcommerce.isStoreInNoEcommerceCountries(selectedCountry?.akamaiCC)) {
        removeRoeCookie()
        removeSetCurrencyCookie()
        NoEcommerce.setNoEcommerceCookie(selectedCountry.akamaiCC)
        selectedCookie = NoEcommerce.getNoEcommerceCountry()
      } else {
        removeRoeCookie()
        removeSetCurrencyCookie()
        NoEcommerce.removeNoEcommerceCookie()
        selectedCookie = null
      }
      if (window.location.origin.includes('.cn')) {
        const urlreplaced = window.location.origin.replace('.cn', '')
        requestedCountryURL = urlreplaced + selectedCountry.url
      } else {
        requestedCountryURL = window.location.origin + selectedCountry.url
      }
      setCurrencyPreference(
        null,
        requestedCountryURL,
        selectedCountry.akamaiCC,
        selectedCookie,
        selectedCountry.currencyROEValue
      )
    },
    getSelected(locale) {
      if (locale.url.includes('/eu')) {
        const euSelected = getRoeCookie()
        if (euSelected) {
          return euSelected === locale.akamaiCC
        } else {
          return this.selected.includes(locale.url)
        }
      } else if (NoEcommerce.isStoreInNoEcommerceCountries(this.value?.akamaiCC)) {
        const noEcomSelected = NoEcommerce.getNoEcommerceCountry()
        if (noEcomSelected) {
          return noEcomSelected === locale.akamaiCC
        } else {
          return this.selected.includes(locale.url)
        }
      } else {
        return this.selected.includes(locale.url)
      }
    },
    getLabel(defaultLabel) {
      // hack for prevent update of label RB-39477
      return this.oldLabel || defaultLabel
    },
  },
}
